module.exports = __webpack_public_path__ + "static/media/a6_postkarte_front.1706f71b.jpg";